import loadable from "@loadable/component";
import React from "react";
import StatusIcon from "../../Icons/StatusIcon";
const StatusListComponent = loadable(
  () => import("../../components/Status/StatusList")
);

const StatusList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Status</span>
      </div>
      <StatusListComponent />
    </>
  );
};

export default StatusList;
